import { Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';

import { MplLinkButton } from '../../atoms/MplButton';

export interface IOwnerState {
	variant?: 'primary_light' | 'primary_dark';
}

export const Root = styled('div')<{ ownerState: IOwnerState }>(
	({ theme, ownerState: { variant = 'primary_light' } }) => ({
		backgroundColor:
			(variant === 'primary_light' && theme.palette.primary.light) ||
			(variant === 'primary_dark' && theme.palette.primary.dark) ||
			undefined,
		display: 'grid',
		gridTemplateRows: 'max-content 1fr',
		height: '100%',
		overflowY: 'auto',
	})
);

export const InitialScreenRoot = styled('div')(() => ({
	display: 'grid',
	gridTemplateRows: '1fr max-content',
}));

export const ContentWrapper = styled('div')(() => ({
	padding: 24,
	boxSizing: 'border-box',
	height: '100%',
	display: 'grid',
	gridAutoFlow: 'row',
	gridAutoRows: 'max-content',
	gridGap: 16,
	position: 'relative',
}));

export const ContentWrapperFlex = styled('div')(() => ({
	padding: 24,
	boxSizing: 'border-box',
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
	gap: 16,
	position: 'relative',
	maxWidth: '100vw',
}));

export const EditUserWrapper = styled('div')(() => ({
	padding: '24px 0',
}));

export const UserGreetingWrapper = styled('div')(() => ({
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr',
	gridGap: 12,
	padding: '8px 0',
}));

export const MyAccountTitleWithButton = styled('div')(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: 'max-content max-content',
	justifyContent: 'space-between',
	alignItems: 'center',

	[theme.breakpoints.up('tabletP')]: {
		justifyContent: 'start',
	},
}));

export const SeparatorLine = styled('div')(() => ({
	width: '100%',
	height: 0,
	border: '1px solid #E7E7E7',
}));

export const MyAccountWrapper = styled('div')(() => ({
	display: 'grid',
	gridTemplateColumns: '1fr',
	gridTemplateRows: 'repeat(6, max-content) 1fr',
	gridGap: 24,
	padding: 24,
	minWidth: 0, // Allow grid items to shrink below their content size

	// Ensure all direct children (data sections) handle text overflow properly
	'& > div': {
		minWidth: 0, // Allow grid items to shrink
		wordBreak: 'break-word',
		overflowWrap: 'break-word',
	},

	'.desktop-data-block &': {
		padding: 0,
	},
}));

export const UserAvatar = styled(Avatar)(() => ({
	width: 50,
	height: 50,
	borderRadius: '50%',
	objectFit: 'cover',
}));

export const UserGreeting = styled('div')(({ theme }) => ({
	display: 'grid',
	gridTemplateRows: 'max-content max-content',
	gridGap: 4,

	'& > span:first-of-type': {
		...theme.typography.body1,
		color: theme.palette.primary.dark,
	},

	'& > span:last-of-type': {
		...theme.typography.body1,
		fontWeight: 600,
		color: theme.palette.primary.dark,
	},
}));

export const LanguageAvatar = styled(Avatar)(({ theme }) => ({
	width: 24,
	height: 24,
	borderRadius: '50%',
	objectFit: 'cover',
	color: theme.palette.primary.dark,
	...theme.typography.body1,
	fontSize: 10,
	fontWeight: 'bold',
}));

export const StepTitle = styled('span')(({ theme }) => ({
	...theme.typography.body1,
	fontWeight: 600,
	color: theme.palette.neutral[100],
}));

export const DesktopRoot = styled('div')(() => ({
	display: 'grid',
	gridAutoFlow: 'row',
	gridAutoRows: 'max-content',
	gridTemplateColumns: 'minmax(auto, 632px)',
	justifyContent: 'center',
	gap: 24,
	padding: 24,
}));

export const DesktopDataBlock = styled('div')(({ theme }) => ({
	background: theme.palette.neutral[0],
	borderRadius: 8,
	overflow: 'hidden',

	padding: 24,
	boxSizing: 'border-box',
}));

export const DesktopDataTitle = styled('span')(({ theme }) => ({
	display: 'inline-block',
	...theme.typography.title,
	color: theme.palette.primary.main,
	marginBottom: 40,
}));

export const ImprintButton = styled(MplLinkButton)(() => ({
	placeSelf: 'center',
	width: 'fit-content',
}));
